import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";

import { useAccount } from "@/hooks/useAccount";

/**
 * Hides admin routes from non-admin users. The backend ALSO enforces
 * [Authorize(Roles="Admin")] on every endpoint, so this is UX-only —
 * a determined non-admin can hit the endpoints directly and get a 401.
 */
export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useAccount();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!data || data.user_role !== "Admin") {
    // 404 rather than 403 so we don't leak which routes exist for admins.
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
